import { Component, Input, OnInit } from '@angular/core';
import { ButtonGroupOptions, ButtonType } from '@shared/ui/buttons';
import { IconType } from '@shared/utils/icons';
import { NavbarHeaderMenuItem } from '@shared/utils/menu-items';
import { AppConfig } from '@shared/utils/app-config';
import { Router } from '@angular/router';
import { AppRoutes } from '@shared/utils/navigation';

@Component({
  selector: 'shared-ui-navbars-navbar-header',
  templateUrl: './navbar-header.component.html',
  styleUrls: ['./navbar-header.component.css'],
  standalone: false,
})
export class NavbarHeaderComponent implements OnInit {
  @Input() heading?: string;
  @Input() imageUrl?: string;
  @Input() subheading?: string;
  @Input() subheadingDropdown?: NavbarHeaderMenuItem[] | null;
  @Input() dropdownPlacement?: string;
  @Input() userDetailsInDropdown = true;
  @Input() userUid?: string;
  @Input() canOpenUserProfile = false;

  buttonOptions: ButtonGroupOptions[] = [];
  ButtonType = ButtonType;
  IconType = IconType;

  constructor(public appConfig: AppConfig, private router: Router) {}

  ngOnInit(): void {
    if (this.subheadingDropdown) {
      this.buttonOptions = this.subheadingDropdown.map((x) => {
        const command = (): void => {
          if (x.link) {
            this.router.navigateByUrl(x.link);
          } else {
            x.callback?.();
          }
        };

        return new ButtonGroupOptions(x.text, command, IconType.None, x.link);
      });
    }

    if (this.userUid && this.canOpenUserProfile) {
      this.buttonOptions.unshift(
        new ButtonGroupOptions(this.heading ?? 'User Dashboard', () => this.openUserDashboard(), IconType.None, undefined, undefined, undefined, undefined, this.subheading)
      );
    }
  }

  openUserDashboard(): void {
    if (this.userUid && this.canOpenUserProfile) {
      this.router.navigate([`/${AppRoutes.Users}/${this.userUid}`]);
    }
  }
}
